import React, { useState, useEffect } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const products = [
  {
    title: "Butt Hinges (3inch)",
    image: "feature.png",
    category: "Standard",
    details: {
      sizes: [
        "3 X 12",
        "3 X 1/2 X 3/4",
        "3 X 3/4 X 3/4",
        "3 X 16",
        "3 X 3/4 X 1",
        "3 X 1 X 1"
      ],
      load: "50–100kg",
      finish: "Satin, Mirror, Brushed"
    },
    launchingSoon: false
  },
  {
    title: "Butt Hinges (4inch)",
    image: "feature.png",
    category: "Standard",
    details: {
      sizes: [
        "4 X 12",
        "4 X 10",
        "4 X 14",
        "4 X 1 X 1",
        "4 X 1 X 1.25"
      ],
      load: "50–100kg",
      finish: "Satin, Mirror, Brushed"
    },
    launchingSoon: false
  },
  {
    title: "Butt Hinges (5inch)",
    image: "feature.png",
    category: "Standard",
    details: {
      sizes: [
        "5 X 12",
        "5 X 10",
        "5 X 14"
      ],
      load: "50–100kg",
      finish: "Satin, Mirror, Brushed"
    },
    launchingSoon: false
  },
  {
    title: "Butt Hinges (6inch)",
    image: "feature.png",
    category: "Standard",
    details: {
      sizes: [
        "6 X 10"
      ],
      load: "50–100kg",
      finish: "Satin, Mirror, Brushed"
    },
    launchingSoon: false
  }
];

export default function Product() {
  const [index, setIndex] = useState(0);
  const [showAll, setShowAll] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [expandedCards, setExpandedCards] = useState(
    Array(products.length).fill(false)
  );

  useEffect(() => {
    const checkScreen = () => setIsMobile(window.innerWidth < 768);
    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  const itemsPerView = isMobile ? 1 : 4;
  const translatePercentage = 100 / itemsPerView;

  const toggleCard = (i) => {
    const updated = [...expandedCards];
    updated[i] = !updated[i];
    setExpandedCards(updated);
  };

  const next = () => {
    if (index < products.length - itemsPerView) {
      setIndex(index + 1);
    }
  };

  const prev = () => {
    if (index > 0) {
      setIndex(index - 1);
    }
  };

  return (
    <div className="relative w-full px-6 mt-[8%] py-10">
      <div className="flex justify-between items-center mb-6">
        <div>
          <h2 className="text-4xl text-shadow font-bold">Products</h2>
          <p className="text-sm text-gray-600 py-2 font-semibold">
            Explore our range of durable hardware solutions today.
          </p>
        </div>
        <button
          onClick={() => setShowAll(true)}
          className="bg-gray-100 text-sm px-4 py-1 rounded shadow border hover:bg-gray-200"
        >
          View all
        </button>
      </div>

      {/* Carousel */}
      <div className="overflow-hidden">
        <div
          className="flex transition-transform duration-500 ease-in-out"
          style={{ transform: `translateX(-${index * translatePercentage}%)` }}
        >
          {products.map((product, i) => (
            <div
              key={i}
              className="flex-shrink-0 w-full md:w-1/4 px-2 flex flex-col items-center"
            >
              <div className="bg-white rounded-md overflow-hidden w-full">
                <img
                  src={product.image}
                  alt={product.title}
                  className="w-full h-56 object-cover"
                />
                {!product.launchingSoon && (
                  <div className="">
                    <div className="bg-[#787777] p-3 roun">
                      <h3 className="font-semibold text-white">
                        {product.title}
                      </h3>
                      <p className="text-sm text-white">{product.category}</p>
                    </div>
                    {expandedCards[i] && (
                      <div className="bg-gray-100 mt-3 p-3 rounded text-left text-sm">
                        <h4 className="font-semibold mb-1">Sizes Available</h4>
                        <ul className="list-disc list-inside space-y-1 text-gray-700">
                          {product.details.sizes.map((size, idx) => (
                            <li key={idx}>{size}</li>
                          ))}
                        </ul>
                        <p className="mt-2 text-gray-700">
                          <span className="font-semibold">Load capacity:</span>{" "}
                          {product.details.load}
                        </p>
                        <p className="text-gray-700">
                          <span className="font-semibold">Finish:</span>{" "}
                          {product.details.finish}
                        </p>
                      </div>
                    )}
                    <div className="flex items-center justify-center">
                      <button
                        onClick={() => toggleCard(i)}
                        className="mt-4 bg-[#01347B] text-white text-sm w-[50%] px-4 py-2 rounded"
                      >
                        {expandedCards[i] ? "View Less" : "View More"}
                      </button>
                    </div>
                  </div>
                )}
                {product.launchingSoon && (
                  <div className="text-center py-4">
                    <p className="text-sm text-gray-600">
                      {product.details[0]}
                    </p>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Arrows */}
      <div className="absolute bottom-10 right-6 flex space-x-3">
        <button
          onClick={prev}
          className="p-2 rounded border hover:bg-gray-100 bg-white shadow"
        >
          <FaChevronLeft />
        </button>
        <button
          onClick={next}
          className="p-2 rounded border hover:bg-gray-100 bg-white shadow"
        >
          <FaChevronRight />
        </button>
      </div>

      {/* Modal View All */}
      {showAll && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white max-w-5xl w-full p-6 rounded-lg relative overflow-y-auto max-h-[90vh]">
            <button
              className="absolute top-4 right-4 text-xl font-bold text-gray-600 hover:text-gray-900"
              onClick={() => setShowAll(false)}
            >
              ✕
            </button>
            <h2 className="text-2xl font-semibold mb-4">All Products</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
              {products.map((product, idx) => (
                <div
                  key={idx}
                  className="bg-white border rounded-lg shadow p-4 text-center"
                >
                  <img
                    src={product.image}
                    alt={product.title}
                    className="w-full h-40 object-cover rounded mb-3"
                  />
                  <h4 className="font-semibold text-lg">{product.title}</h4>
                  <p className="text-sm text-gray-500 mb-2">
                    {product.category}
                  </p>

                  <div className="text-left text-sm mt-2 bg-gray-50 p-2 rounded">
                    <h5 className="font-semibold mb-1">Sizes Available</h5>
                    <ul className="list-disc list-inside text-gray-700 mb-2">
                      {product.details.sizes.map((size, i) => (
                        <li key={i}>{size}</li>
                      ))}
                    </ul>
                    <p className="text-gray-700 mb-1">
                      <span className="font-semibold">Load capacity:</span>{" "}
                      {product.details.load}
                    </p>
                    <p className="text-gray-700">
                      <span className="font-semibold">Finish:</span>{" "}
                      {product.details.finish}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
